(function () {
  if (window.__ovInit) return;
  window.__ovInit = true;

  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Todos los CTA abren el formulario COD de EasySell --- */
  function abrirCOD(e) {
    var btn = document.getElementById('es-popup-button') ||
              document.querySelector('.es-popup-button, .es-popup-button-product');
    if (btn) { if (e) e.preventDefault(); btn.click(); return true; }
    var f = document.getElementById('es-form-container') || document.getElementById('es-form');
    if (f) { if (e) e.preventDefault(); f.scrollIntoView({ behavior: 'smooth', block: 'center' }); return true; }
    return false;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ov-buy]') : null;
    if (t) abrirCOD(e);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ov-back]') : null;
    if (!t) return;
    e.preventDefault();
    var d = document.querySelector('[data-ov-offer]');
    if (d) d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  /* --- Contador perpetuo --- */
  function contador() {
    var els = document.querySelectorAll('[data-ov-timer]');
    if (!els.length) return;
    els.forEach(function (el) {
      var mins = parseInt(el.getAttribute('data-ov-timer'), 10) || 20;
      var KEY = 'ov_timer_' + (el.getAttribute('data-ov-key') || 'x');
      var fin;
      try {
        fin = parseInt(sessionStorage.getItem(KEY) || '0', 10);
        if (!fin || fin < Date.now()) { fin = Date.now() + mins * 60000; sessionStorage.setItem(KEY, String(fin)); }
      } catch (err) { fin = Date.now() + mins * 60000; }
      (function tick() {
        var d = Math.max(0, fin - Date.now());
        var m = Math.floor(d / 60000), s = Math.floor((d % 60000) / 1000);
        el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (d > 0) setTimeout(tick, 1000);
      })();
    });
  }

  /* --- Observador con red de seguridad ---------------------------------
     El IntersectionObserver falla en navegadores embebidos, WebViews y
     algunas apps (Instagram, Facebook), que es justo por donde llega el
     trafico de los anuncios. Por eso NUNCA se depende solo de el: cada
     elemento queda tambien en una lista que se revisa al hacer scroll. */
  var io = null;
  var pendientes = [];
  var escuchando = false;

  function enPantalla(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h * 0.92 && r.bottom > 0;
  }

  function revisar() {
    for (var i = pendientes.length - 1; i >= 0; i--) {
      if (enPantalla(pendientes[i].el)) {
        var p = pendientes.splice(i, 1)[0];
        p.fn(p.el);
      }
    }
    if (!pendientes.length && escuchando) {
      window.removeEventListener('scroll', revisar);
      escuchando = false;
    }
  }

  function observar(nodo, alEntrar) {
    if (quieto) { alEntrar(nodo); return; }

    var hecho = false;
    var unaVez = function (n) { if (hecho) return; hecho = true; alEntrar(n); };

    if ('IntersectionObserver' in window) {
      if (!io) {
        io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            var fn = en.target.__ovFn;
            if (fn) fn(en.target);
          });
        }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      }
      nodo.__ovFn = unaVez;
      io.observe(nodo);
    }

    pendientes.push({ el: nodo, fn: unaVez });
    if (!escuchando) { window.addEventListener('scroll', revisar, { passive: true }); escuchando = true; }
    setTimeout(revisar, 250);
  }

  /* --- Aparicion escalonada de cada seccion --- */
  function revelar() {
    document.querySelectorAll('.ov-page .ov-wrap').forEach(function (w) {
      if (w.classList.contains('ov-rev')) return;
      w.classList.add('ov-rev');
      observar(w, function (n) { n.classList.add('on'); });
      setTimeout(function () { w.classList.add('on'); }, 4000);
    });
  }

  /* --- Numeros y barras --- */
  function animar() {
    document.querySelectorAll('[data-ov-count], [data-ov-fill]').forEach(function (n) {
      if (n.__ovAnim) return;
      n.__ovAnim = true;

      var suf = n.getAttribute('data-ov-suf');
      if (suf === null) suf = '%';

      function pintar(el) {
        if (el.hasAttribute('data-ov-fill')) {
          el.style.width = el.getAttribute('data-ov-fill') + '%';
          return;
        }
        var meta = parseInt(el.getAttribute('data-ov-count'), 10) || 0;
        if (quieto) { el.textContent = meta + suf; return; }
        var t0 = Date.now();
        /* setTimeout y no requestAnimationFrame: rAF no se ejecuta en pestanas
           de segundo plano y el numero se quedaba clavado en 0 para siempre. */
        (function paso() {
          var p = Math.min(1, (Date.now() - t0) / 1200);
          el.textContent = Math.round(meta * (1 - Math.pow(1 - p, 3))) + suf;
          if (p < 1) setTimeout(paso, 16);
        })();
      }

      observar(n, pintar);

      /* Ultimo recurso: si a los 5 s sigue en cero teniendolo en pantalla,
         se muestra el numero final. Mejor sin animacion que un 0% mintiendo. */
      setTimeout(function () {
        if (n.hasAttribute('data-ov-count') && enPantalla(n) && /^0/.test(n.textContent)) {
          n.textContent = (parseInt(n.getAttribute('data-ov-count'), 10) || 0) + suf;
        }
      }, 5000);
    });
  }

  /* --- La curva se dibuja al entrar --- */
  function curvas() {
    document.querySelectorAll('.ov-cv').forEach(function (c) {
      observar(c, function (n) { n.classList.add('on'); });
      setTimeout(function () { c.classList.add('on'); }, 4000);
    });
  }

  /* --- Barra flotante --- */
  function sticky() {
    var bar = document.querySelector('[data-ov-sticky]');
    var ref = document.querySelector('[data-ov-offer]');
    if (!bar) return;
    function ver() {
      var pasado = ref ? (ref.getBoundingClientRect().bottom < 0) : (window.scrollY > 600);
      bar.classList.toggle('on', pasado);
    }
    window.addEventListener('scroll', ver, { passive: true });
    ver();
  }

  function init() { contador(); revelar(); animar(); curvas(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  /* Al volver de una pestana en segundo plano, recuperar lo que quedo a medias */
  document.addEventListener('visibilitychange', function () { if (!document.hidden) revisar(); });
})();
